import React, { useEffect, useRef, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import "./DropDownFilter.css"
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import ClearIcon from '@mui/icons-material/Clear'

let key = 0

function DropDownFilter(props) {
  const [searchValue, setSearchValue] = useState("")

  const dispatch = useDispatch()

  const ref = useRef(null)
  const idList = props.idList
  const isMulti = Boolean(props.multiselect)
  const isClearable = props.clearable !== false

  const onClickOutside = () => {
    const dropdownList = document.querySelectorAll(`#${idList}`)

    Array.from(dropdownList).forEach(dropdown => {
      dropdown.classList.remove("active")
    })
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside && onClickOutside()
      }
    }
    document.addEventListener("click", handleClickOutside, true)

    return () => {
      document.removeEventListener("click", handleClickOutside, true)
    }
  }, [onClickOutside])

  const handleClickDropdown = (event) => {
    const dropdownList = event.currentTarget.nextSibling
    const hasValue = isMulti ? Array.isArray(props.value) && props.value.length > 0 : props.value !== ""

    if (!hasValue || !isClearable) {
      dropdownList.classList.toggle("active")
      const searchBar = document.getElementById(`search-bar--${idList}`)
      searchBar && searchBar.focus()
    } else {
      if (isMulti) {
        // Clear all selections via onChange
        typeof props.onChange === 'function' && props.onChange([])
      } else {
        if (typeof props.onChange === 'function') {
          props.onChange(typeof props.listArray[0] === 'object' ? { id: null, name: "" } : "")
          return
        }

        const updatedFilters = { ...props.filters }

        if (typeof props.listArray[0] === 'object') {
          updatedFilters[props.filter] = {"id": null, "name": ""}
        } else {
          updatedFilters[props.filter] = ""
        }

        dispatch(props.setValue(updatedFilters))
        document.getElementById(idList).previousSibling.firstChild.innerHTML = props.placeholderText
      }
    }
  }

  const handleOnClickItem = (event, value) => {
    if (isMulti) {
      // For multiselect, toggle value in array and keep dropdown open
      const current = Array.isArray(props.value) ? props.value.slice() : []
      const valueToToggle = typeof value === 'object' ? value.id : value
      const idx = current.indexOf(valueToToggle)
      if (idx >= 0) {
        current.splice(idx, 1)
      } else {
        current.push(valueToToggle)
      }
      typeof props.onChange === 'function' && props.onChange(current)
    } else {
      event.target.parentElement.classList.toggle("active")
      if (typeof props.onChange === 'function') {
        props.onChange(value)
      } else {
        props.onClickItem(event, value, props.idList)
      }
    }
  }

  return (
    <div className="dropdown__container filter flex--vert" ref={ref}>
      <span className="input_field__input_box--text--filter" onClick={handleClickDropdown}>
        <p className="dropdown-input--text_field">{
          isMulti
            ? ((Array.isArray(props.value) && props.value.length > 0)
                ? `${props.value.length} selected`
                : props.placeholderText)
            : (props.value == "" ? props.placeholderText : props.value)
        }</p>
        {
          isMulti
            ? ((Array.isArray(props.value) && props.value.length > 0) ? <ClearIcon /> : <KeyboardArrowDownIcon />)
            : (props.value == "" || !isClearable ? <KeyboardArrowDownIcon /> : <ClearIcon />)
        }
      </span>
      <ul className="input_field__dropdown filter" id={idList}>
        <input className="search-bar" id={`search-bar--${idList}`} placeholder="Search..." value={searchValue} onChange={event => setSearchValue(event.currentTarget.value)} autoComplete="off" />
        {
          props.listArray
            .filter(item => {
              if (typeof item === "object") {
                if (props.searchType == "startsWith") {
                  return item.name.toLocaleLowerCase().startsWith(searchValue)
                }

                return item.name.toLocaleLowerCase().includes(searchValue)
              } else {
                if (props.searchType == "startsWith") {
                  return item.toLocaleLowerCase().startsWith(searchValue)
                }

                return item.toLocaleLowerCase().includes(searchValue)
              }
            })
            .map(item => {
              const isObject = typeof item === "object"
              const itemId = isObject ? item.id : item
              const itemLabel = isObject ? item.name : item
              const selected = isMulti && Array.isArray(props.value) && props.value.includes(itemId)
              return (
                <li
                  key={key++}
                  onClick={(event) => handleOnClickItem(event, item)}
                  data-id={isObject ? item.id : undefined}
                  className={selected ? "selected" : ""}
                >
                  {itemLabel}
                </li>
              )
            })
        }
      </ul>
    </div>
  )
}

export default DropDownFilter
